




























































































































































































































































































































































































































































/** @format */

import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import TrafficDataChart from './components/traffic-data-chart.vue';
import RevenueDataLine from './components/revenue-data-line.vue';
import RevenueDataPie from './components/revenue-data-pie.vue';
import infiniteScroll from './components/infinite-scroll.vue';
import ParkMap from './components/park-map.vue';

import {
  getOverviewDataVisualization,
  trafficDate,
  revenueDate,
  abnormalTraffic,
  fiveabnormalTraffic,
  trafficFlow,
  datavOperation,
  operationFiveMinute,
  getParkIds,
  realTimeTraffic,
  realRevenueDate,
  temporaryRevenueChannelRate,
  mapParking
} from '@/api/monitor';
import * as _ from 'lodash';
import Utils from '@/utils/common';
import { getUserId, checkLogin, getDataVConfig } from '@/api/system-management/index';
import { gsap } from 'gsap';

export interface IMap {
  center: string;
  cityId: string;
  parkName: string;
  cityName: string;
  parkingNum: Number;
  trafficFlow: Number;
  latitude: string; //纬度
  longitude: string; //经度
  provinceName: string; //省名称
  provinceId: string; //省Id
}
import localCache from '@/utils/local-cache';
@Component({
  components: { infiniteScroll, TrafficDataChart, RevenueDataLine, RevenueDataPie, ParkMap }
})
export default class rightScreen extends Vue {
  childWidth: any;
  clickWidth() {
    this.childWidth = 0.2;
  }
  @Prop()
  userId?: any; //userId用户Id

  @Prop()
  orgId?: any; //orgId组织Id

  @Prop()
  orgDepName?: any; //orgDepName名字

  @Watch('orgDepId')
  orgDepIdChanged(val: boolean) {
    if (val) {
      this.operationDtos = [];
    }
  }

  // 是否全屏
  @Prop({ default: true })
  isFull?: boolean;

  provinceId: String = ''; //省份Id

  on: boolean = true;
  zaixianTranslate: boolean = true;
  revenueTranslate: boolean = true;
  trafficTranslate: boolean = true;
  dataUserId: any = '';
  systemTime: any = '';
  systemHour: any = '';
  systemMin: any = '';
  systemSec: any = '';
  trafficStatus = 0;
  revenueStatus = 0;
  trafficFlowStatus = 0;
  trafficTab = [{ label: '今日' }, { label: '七日' }];
  trafficTab1 = [{ label: '出场' }, { label: '进场' }];
  //总览
  parkNumTweened = 0;
  parkingSpaceNumTweened = 0;
  todayPaymentNumTweened = 0;
  todayRevenueSumTweened = 0;
  orgDepId: any = '';
  datavConfig: string = '00';
  get parkNum() {
    return this.parkNumTweened.toFixed(0);
  }
  get parkingSpaceNum() {
    return this.parkingSpaceNumTweened.toFixed(0);
  }
  get todayPaymentNum() {
    return this.todayPaymentNumTweened.toFixed(0);
  }
  get todayRevenueSum() {
    return this.todayRevenueSumTweened.toFixed(0);
  }
  //通行
  trafficRateTweened = 0;
  todayEnterTweened = 0;
  todayOutTweened = 0;
  get todayEnterTraffic() {
    return this.todayEnterTweened.toFixed(0);
  }
  get trafficRate() {
    const isxiaoshu = String(Number(this.trafficRateTweened * 100));
    if (isxiaoshu.indexOf('.') > -1) {
      return Number(this.trafficRateTweened * 100).toFixed(2);
    }
    return Number(this.trafficRateTweened * 100).toFixed(0);
  }
  get todayOutTraffic() {
    return this.todayOutTweened.toFixed(0);
  }
  trafficData = {
    trafficxAxisData: [],
    trafficSeriesExitData: [], //出场数据
    trafficSeriesEnterData: [] //进场数据
  };
  //营收
  monthCardTweened = 0;
  temporaryRateTweened = 0;
  temporaryRevenueTweened = 0;
  get monthCardRevenue() {
    return this.monthCardTweened.toFixed(0);
  }
  get temporaryRate() {
    const isxiaoshu = String(Number(this.temporaryRateTweened * 100));
    if (isxiaoshu.indexOf('.') > -1) {
      return Number(this.temporaryRateTweened * 100).toFixed(2);
    }
    return Number(this.temporaryRateTweened * 100).toFixed(0);
  }
  get temporaryRevenue() {
    return this.temporaryRevenueTweened.toFixed(0);
  }
  revenueLineData = {
    revenuexAxisData: [],
    revenueSeriesData: []
  };
  revenuePieData = {
    legendData: [],
    seriesData: []
  };
  payMethodsMap = {
    '00': '现金',
    '01': '微信',
    '02': '支付宝',
    '03': '其他'
  };
  screenLoading: boolean = true;
  // 01（00：车场连接，01：车场离线，02：设备连接，03：设备离线，04：设备故障）
  typesMap(val) {
    if (!val) return '';
    if (val == '00') return '车场连接';
    if (val == '01') return '车场离线';
    if (val == '02') return '设备连接';
    if (val == '03') return '设备离线';
    if (val == '04') return '设备故障';
  }

  // （原因类型， '03' '跟车出场' '04' '清理出场' '05' '特殊放行' '06' '被冲出场' ’07’'手动抬杆'）
  whyTypesMap(val) {
    if (!val) return '';
    if (val == '3') return '特殊放行';
    if (val == '4') return '清理出场';
    if (val == '6') return '重复入场';
    if (val == '7') return '手动抬杆';
    if (val == '8') return '被冲出场';
  }
  whyTypescolorMap(val) {
    if (!val) return '';
    if (val == '3') return 'red-bgc';
    if (val == '4') return 'orange-bgc';
    if (val == '6') return 'green-bgc';
    if (val == '7') return 'purple-bgc';
    if (val == '8') return 'yellow-bgc';
  }
  getcolor(val) {
    if (!val) return 'show-progress yellow';
    if (val == '0') return `show-progress yellow`;
    if (val == '1') return `show-progress pink`;
    if (val == '2') return `show-progress purple`;
    if (val == '3') return `show-progress orange`;
    if (val == '4') return `show-progress blue`;
  }
  getTypes(val) {
    if (!val) return '';
    if (val == '00') return 'check-circle';
    if (val == '01') return 'exclamation-circle';
    if (val == '02') return 'exclamation-circle';
    if (val == '03') return 'exclamation-circle';
    if (val == '04') return 'exclamation-circle';
  }
  timer: any = null;
  payColorMap = {
    '00': '#ff6e59',
    '01': '#57FFC5',
    '02': '#47d4ff',
    '03': '#f6cf37'
  };
  //获取类名
  getClassName(value) {
    if (value == '00') return 'has-circle cash';
    if (value == '01') return 'has-circle enter';
    if (value == '02') return 'has-circle exit';
    if (value == '03') return 'has-circle relative';
  }

  //进出场流量
  //进场流量
  enterTrafficFlow = [];
  //出场流量
  outTrafficFlow = [];
  maxFlowNum = 3;
  lintingLeftList = [
    // { name: '现金', method: '00', value: '12' },
    // { name: '微信', method: '01', value: '12' },
    // { name: '支付宝', method: '02', value: '12' },
    // { name: '其他', method: '03', value: '12' },
  ];
  colorList: any = ['#ff6e59', '#57FFC5', '#47A2FF', '#f6cf37'];

  //获取tab切换时实时通行数据
  getTabTraffic() {
    this.trafficData.trafficxAxisData =
      this.trafficStatus == 0 ? this.trafficDaily.dailyLegend : this.trafficWeekly.weeklyLegend;
    this.trafficData.trafficSeriesEnterData =
      this.trafficStatus == 0 ? this.trafficDaily.enterTrafficList : this.trafficWeekly.enterTrafficList;
    this.trafficData.trafficSeriesExitData =
      this.trafficStatus == 0 ? this.trafficDaily.outTrafficList : this.trafficWeekly.outTrafficList;
    try {
      const { refreshChart } = this.$refs.trafficCahrt as any;
      refreshChart && refreshChart();
    } catch (e) {
      console.error(e);
    }
  }
  //获取tab切换时营收折线图的数据
  getTabrevenue() {
    this.revenueLineData.revenuexAxisData =
      this.revenueStatus == 0 ? this.revenueDaily.dailyLegend : this.revenueWeekly.weeklyLegend;
    this.revenueLineData.revenueSeriesData =
      this.revenueStatus == 0 ? this.revenueDaily.dataList : this.revenueWeekly.dataList;

    try {
      const { refreshChart } = this.$refs.revenueLine as any;
      refreshChart && refreshChart();
    } catch (e) {
      console.error(e);
    }
  }
  //获取tab
  selectTab(seleted, index) {
    if (seleted == 'trafficStatus') {
      this.trafficStatus = index;
      this.getTabTraffic();
    } else if (seleted == 'revenueStatus') {
      this.revenueStatus = index;
      this.getTabrevenue();
    }
  }
  //异常
  abnormalList = [];
  fadeName: any = 'abnormal-li fade-out-section is-visible';
  animate = false;
  endId = '';
  isLenght = false;
  abnormalTimer: any = null;
  systemTimer: any = null;
  timeFive: any = null;
  parkIds: any[] = [];
  tenTimer: any = null;
  thirtyTimer: any = null;
  //总览接口
  async getOverviewDataVisualizationData() {
    let json = { parkIds: this.parkIds };
    try {
      const { data } = await getOverviewDataVisualization(json);
      // this.parkNum = data.parkNum
      // this.parkingSpaceNum = data.parkingSpaceNum
      // this.todayPaymentNum = data.todayPaymentNum
      // this.todayRevenueSum = data.todayRevenueSum
      gsap.to(this.$data, { duration: 0.5, parkNumTweened: data.parkNum || 0 });
      gsap.to(this.$data, { duration: 0.5, parkingSpaceNumTweened: data.parkingSpaceNum || 0 });
      gsap.to(this.$data, { duration: 0.5, todayPaymentNumTweened: data.todayPaymentNum || 0 });
      gsap.to(this.$data, { duration: 0.5, todayRevenueSumTweened: data.todayRevenueSum || 0 });
    } catch (e) {
      console.log(e);
      this.$message.error((e && e.msg) || '获取数据失败');
    }
  }

  //通行(统计数据)
  async getTrafficData() {
    let json = { parkIds: this.parkIds };
    try {
      const { data } = await trafficDate(json);
      //this.trafficRate = data.trafficRate
      //this.todayEnterTraffic = data.todayEnterTraffic
      //this.todayOutTraffic = data.todayOutTraffic
      //this.trafficTranslate = !this.trafficTranslate
      gsap.to(this.$data, { duration: 0.5, trafficRateTweened: data.trafficRate || 0 });
      gsap.to(this.$data, { duration: 0.5, todayEnterTweened: data.todayEnterTraffic || 0 });
      gsap.to(this.$data, { duration: 0.5, todayOutTweened: data.todayOutTraffic || 0 });
    } catch (e) {
      console.log(e);
      this.$message.error((e && e.msg) || '获取数据失败');
    }
  }
  //通行每日
  trafficDaily = {
    outTrafficList: [],
    enterTrafficList: [],
    dailyLegend: []
  };
  //通行七日
  trafficWeekly = {
    outTrafficList: [],
    enterTrafficList: [],
    weeklyLegend: []
  };
  //通行折线数据
  async getTrafficLineData() {
    let json = { parkIds: this.parkIds };
    try {
      const { data } = await realTimeTraffic(json);
      //通行每日
      this.trafficDaily = {
        outTrafficList: [],
        enterTrafficList: [],
        dailyLegend: []
      };
      //通行七日
      this.trafficWeekly = {
        outTrafficList: [],
        enterTrafficList: [],
        weeklyLegend: []
      };
      if (data.daily.outTrafficList && data.daily.outTrafficList.length > 0) {
        for (let i = 0; i < data.daily.outTrafficList.length; i++) {
          this.trafficDaily.dailyLegend.push(`${data.daily.outTrafficList[i].time}点`);
          this.trafficDaily.outTrafficList.push(data.daily.outTrafficList[i].num);
        }
      }
      if (data.weekly.outTrafficList && data.weekly.outTrafficList.length > 0) {
        for (let i = 0; i < data.weekly.outTrafficList.length; i++) {
          this.trafficWeekly.weeklyLegend.push(data.weekly.outTrafficList[i].time);
          this.trafficWeekly.outTrafficList.push(data.weekly.outTrafficList[i].num);
        }
      }
      if (data.daily.enterTrafficList && data.daily.enterTrafficList.length > 0) {
        for (let i = 0; i < data.daily.enterTrafficList.length; i++) {
          this.trafficDaily.enterTrafficList.push(data.daily.enterTrafficList[i].num);
        }
      }
      if (data.weekly.enterTrafficList && data.weekly.enterTrafficList.length > 0) {
        for (let i = 0; i < data.weekly.enterTrafficList.length; i++) {
          this.trafficWeekly.enterTrafficList.push(data.weekly.enterTrafficList[i].num);
        }
      }
      this.getTabTraffic();
    } catch (e) {
      console.log(e);
      this.$message.error((e && e.msg) || '获取数据失败');
    }
  }

  //营收(总览)
  async getRevenueDate() {
    let json = { parkIds: this.parkIds };
    try {
      const { data } = await revenueDate(json);
      // this.monthCardRevenue = data.monthCardRevenue
      // this.temporaryRate = data.temporaryRate
      // this.temporaryRevenue = data.temporaryRevenue
      gsap.to(this.$data, { duration: 0.5, monthCardTweened: data.monthCardRevenue || 0 });
      gsap.to(this.$data, { duration: 0.5, temporaryRateTweened: data.temporaryRate || 0 });
      gsap.to(this.$data, { duration: 0.5, temporaryRevenueTweened: data.temporaryRevenue || 0 });
      //this.revenueTranslate = !this.revenueTranslate
    } catch (e) {
      console.log('报错', e);
      this.$message.error((e && e.msg) || '获取数据失败');
    }
  }

  //营收每日
  revenueDaily = {
    dataList: [],
    dailyLegend: []
  };
  //营收七日
  revenueWeekly = {
    dataList: [],
    weeklyLegend: []
  };
  //营收 （折线）
  async getRevenueLineDate() {
    let json = { parkIds: this.parkIds };
    //营收每日
    this.revenueDaily = {
      dataList: [],
      dailyLegend: []
    };
    //营收七日
    this.revenueWeekly = {
      dataList: [],
      weeklyLegend: []
    };
    try {
      const { data } = await realRevenueDate(json);
      for (let i = 0; i < data.daily.length; i++) {
        this.revenueDaily.dataList.push(data.daily[i].num);
        this.revenueDaily.dailyLegend.push(`${data.daily[i].time}点`);
      }
      for (let j = 0; j < data.weekly.length; j++) {
        this.revenueWeekly.dataList.push(data.weekly[j].num);
        this.revenueWeekly.weeklyLegend.push(data.weekly[j].time);
      }
      this.getTabrevenue();
    } catch (e) {
      console.log('报错', e);
      this.$message.error((e && e.msg) || '营收折线数据获取失败');
    }
  }
  //支付渠道
  async getPayData() {
    let json = { parkIds: this.parkIds };
    this.revenuePieData = {
      legendData: [],
      seriesData: []
    };
    try {
      const { data } = await temporaryRevenueChannelRate(json);
      if (data.length > 0) {
        for (let j = 0; j < data.length; j++) {
          let a = data[j];
          this.revenuePieData.legendData.push(this.payMethodsMap[a.payMethod]);
          this.revenuePieData.seriesData.push({
            value: a.amount,
            name: this.payMethodsMap[a.payMethod],
            method: a.payMethod,
            label: { color: this.payColorMap[a.payMethod] }
          });
        }
      } else {
        this.revenuePieData.legendData = ['现金', '微信', '支付宝', '其他'];
        this.revenuePieData.seriesData = [
          {
            value: '0',
            name: '现金',
            method: '00',
            label: { color: '#ff6e59' }
          },
          {
            value: '0',
            name: '微信',
            method: '01',
            label: { color: '#57FFC5' }
          },
          {
            value: '0',
            name: '支付宝',
            method: '02',
            label: { color: '#47d4ff' }
          },
          {
            value: '0',
            name: '其他',
            method: '03',
            label: { color: '#f6cf37' }
          }
        ];
      }
      try {
        const { refreshChart } = this.$refs.revenuePie as any;
        refreshChart && refreshChart();
      } catch (e) {
        console.error(e);
      }
    } catch (e) {
      console.error(e);
      this.$message.error((e && e.msg) || '获取数据失败');
    }
  }

  //地图
  mapData: any[] = [];
  mapRanges: any[] = [];
  mapDataInterval: any = {
    list: [],
    type: 'map'
  };
  mapDataTimer = null;
  async getParkingMap() {
    let json = { parkIds: this.parkIds };
    this.mapData = [];
    this.mapDataInterval = {
      list: [],
      type: 'map'
    };
    try {
      const { data } = await mapParking(json);
      if (data.length > 0) {
        for (let j = 0; j < data.length; j++) {
          let a: IMap = data[j];
          if (a.center) {
            a.latitude = a.center.split(',')[1];
            a.longitude = a.center.split(',')[0];
          }
          if (a.center) {
            this.mapDataInterval.list.push(a);
            // this.mapData.push(a)
          }
        }
      }
    } catch (e) {
      console.log(e);
      this.$message.error((e && e.msg) || '获取数据失败');
    } finally {
      this.screenLoading = false;
      this.mapRanges = this.getMapDataRanges();
      console.log(this.mapRanges);
      this.mapDataTimer = setInterval(() => {
        this.mapItem();
      }, 200);
    }
  }
  getMapDataRanges() {
    let ranges = [];
    if (this.mapDataInterval.list && this.mapDataInterval.list.length) {
      let maxValue = _.maxBy<any>(this.mapDataInterval.list, i => i.parkingNum).parkingNum;
      if (this.mapDataInterval.list.length == 1) return (ranges = [maxValue]);
      if (maxValue < 3) {
        ranges = [1, 2];
      } else {
        let tick = Math.round(maxValue / 3);
        ranges = [tick, tick * 2];
      }
    }
    return ranges;
  }
  //地图挨个出现
  mapItem() {
    try {
      const { refreshMap } = this.$refs.parkingMap as any;
      if (this.mapDataInterval.list.length == 0) {
        if (this.mapDataTimer) {
          clearInterval(this.mapDataTimer);
        }
        return refreshMap && refreshMap();
      }
      this.mapData.push(this.mapDataInterval.list[0]);
      this.mapDataInterval.list.shift();
      refreshMap && refreshMap();
    } catch (e) {
      console.error(e);
    }
  }
  anomalousList = [];
  abnormalListNum = [1, 2, 3, 4, 5];
  anomalousListNum = [1, 2, 3, 4, 5];
  hasConcatedGarbageData = false;
  // 实时异常通行
  async getabnormalTraffic() {
    let json = { parkIds: this.parkIds };
    try {
      const { data } = await abnormalTraffic(json);
      this.abnormalList = data.cumulativeAbnormalTrafficList || [];
      this.anomalousList = data.realTimeAbnormalTrafficList || [];
      if (this.abnormalList) {
        if (this.abnormalList && this.abnormalList.length > 5) {
          this.abnormalList.length = 5;
        }
      }
      // 多彩进度条
      setTimeout(() => {
        let arr = document.getElementsByClassName('show-progress') as any;
        let a = [];
        for (let t = 0; t < this.abnormalList.length; t++) {
          for (let b = 0; b < this.abnormalList[t].detailList.length; b++) {
            if (this.abnormalList[t].detailList[b].rate > 0) {
              a.push(this.abnormalList[t].detailList[b].rate);
            }
          }
        }
        for (let j = 0; j < arr.length; j++) {
          arr[j].style.width = `${a[j] * 100}%`;
        }
      }, 10);
      // 动画滚动
    } catch (e) {
      console.log(e);
      this.$message.error((e && e.msg) || '获取数据失败');
    } finally {
      let arr = [];
      if (this.anomalousList.length < 7) {
        let strlength = this.anomalousList.length;
        let arrlength = 6 - strlength;
        arr = [
          {
            guid: this.guid(),
            v: '',
            parkName: '',
            time: '',
            reasonType: '',
            garbage: true,
            id: 'i am garbage1'
          },
          {
            guid: this.guid(),
            v: '',
            parkName: '',
            time: '',
            reasonType: '',
            garbage: true,
            id: 'i am garbage2'
          },
          {
            guid: this.guid(),
            v: '',
            parkName: '',
            time: '',
            reasonType: '',
            garbage: true,
            id: 'i am garbage3'
          },
          {
            guid: this.guid(),
            v: '',
            parkName: '',
            time: '',
            reasonType: '',
            garbage: true,
            id: 'i am garbage4'
          },
          {
            guid: this.guid(),
            v: '',
            parkName: '',
            time: '',
            reasonType: '',
            garbage: true,
            id: 'i am garbage5'
          }
        ];
        arr.length = arrlength;
      }

      this.$nextTick(() => {
        try {
          if (!this.$refs['excepReason'] as any) return;
          const { appendData } = this.$refs['excepReason'] as any;
          if (!appendData) return;
          appendData &&
            appendData(
              this.anomalousList
                .map((item, index) => ({
                  guid: this.guid(),
                  v: item,
                  parkName: item.parkName,
                  time: item.time,
                  reasonType: item.reasonType,
                  index: index,
                  flags: index == 0,
                  // garbage: index >= 2,
                  id: '' + Date.now() + Math.random()
                }))
                .concat(arr),
              (this.hasConcatedGarbageData = true)
            );
        } catch (e) {
          console.error(e);
        }
      });
    }
  }
  // 实时异常通行 5秒更新
  async getfiveabnormalTraffic() {
    let json = { parkIds: this.parkIds };
    try {
      const { data } = await fiveabnormalTraffic(json);
      //console.log('res', res)
      this.abnormalList = data.cumulativeAbnormalTrafficList || [];
      // this.anomalousList = data.realTimeAbnormalTrafficList || []
      if (data && data.realTimeAbnormalTrafficList && data.realTimeAbnormalTrafficList.length > 0) {
        this.anomalousList = data.realTimeAbnormalTrafficList || [];
        this.$nextTick(() => {
          try {
            (this.$refs['excepReason'] as any).appendData(
              this.anomalousList.map((item, index) => ({
                guid: this.guid(),
                v: item,
                parkName: item.parkName,
                time: item.time,
                reasonType: item.reasonType,
                index: index,
                flags: index == 0,
                // garbage: index >= 2,
                id: '' + Date.now() + Math.random()
              }))
            );
          } catch (e) {
            console.log(e);
          }
        });
      }
      if (this.abnormalList) {
        if (this.abnormalList && this.abnormalList.length > 5) {
          this.abnormalList.length = 5;
        }
      }
      // 多彩进度条
      setTimeout(() => {
        let arr: any = document.getElementsByClassName('show-progress');
        let a = [];
        for (let t = 0; t < this.abnormalList.length; t++) {
          for (let b = 0; b < this.abnormalList[t].detailList.length; b++) {
            if (this.abnormalList[t].detailList[b].rate > 0) {
              a.push(this.abnormalList[t].detailList[b].rate);
            }
          }
        }
        for (let j = 0; j < arr.length; j++) {
          arr[j].style.width = `${a[j] * 100}%`;
        }
      }, 10);
    } catch (e) {
      console.log(e);
      this.$message.error((e && e.msg) || '获取数据失败');
    }
  }

  guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
      var r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
  // shuffle() {
  //   //this.abnormalListNum = _.shuffle(this.abnormalListNum)
  //   // this.anomalousListNum = _.shuffle(this.anomalousListNum)
  //   // this.abnormalListNum = _.shuffle(this.abnormalListNum)
  //   // this.anomalousListNum = _.shuffle(this.anomalousListNum)
  //   // this.anomalousListNum = this.anomalousListNum.unshift(this.anomalousListNum + 1)
  //   // this.operationDtosNum = _.shuffle(this.operationDtosNum)
  // }

  // 实时运维
  // onlineParkNum = ''
  // onlineRate = ''
  operationDtos = [];
  operationDtosNum = [1, 2, 3, 4];
  appendDataLoop = false;

  onlineParkNumTweened = 0;
  onlineRateTweened = 0;
  get onlineParkNum() {
    return this.onlineParkNumTweened.toFixed(0);
  }
  get onlineRate() {
    const isxiaoshu = String(Number(this.onlineRateTweened * 100));
    if (isxiaoshu.indexOf('.') > -1) {
      return Number(this.onlineRateTweened * 100).toFixed(2);
    }
    return Number(this.onlineRateTweened * 100).toFixed(0);
  }
  // rowHeight = 120 //定义滚动的每一行高度为30px
  myShake(block, percent) {
    // block.style.transform = `scale(${Math.abs(percent - 0.5) * 2})`
  }
  hasdatavGarbageData = false;
  async getdatavOperation() {
    let json = { parkIds: this.parkIds };
    try {
      const res = await datavOperation(json);
      if (res.data && res.data.onlineParkNum && res.data.onlineRate && res.data.operationDtos) {
        const { onlineParkNum, onlineRate, operationDtos } = res.data;
        gsap.to(this.$data, { duration: 0.5, onlineParkNumTweened: res.data.onlineParkNum || 0 });
        gsap.to(this.$data, { duration: 0.5, onlineRateTweened: res.data.onlineRate || 0 });
        this.operationDtos = operationDtos || [];
      } else {
        gsap.to(this.$data, { duration: 0.5, onlineParkNumTweened: res.data.onlineParkNum || 0 });
        gsap.to(this.$data, { duration: 0.5, onlineRateTweened: res.data.onlineRate || 0 });
        this.operationDtos = [];
      }
      this.zaixianTranslate = !this.zaixianTranslate;
    } catch (e) {
      this.$message.error((e && e.msg) || '获取数据失败');
    } finally {
      let arr = [];
      if (this.operationDtos.length < 4) {
        let strlength = this.operationDtos.length;
        let arrlength = 4 - strlength;
        arr = [
          {
            guid: this.guid(),
            v: '',
            parkName: '',
            time: '',
            type: '',
            garbage: true,
            id: 'garbage1'
          },
          {
            guid: this.guid(),
            v: '',
            parkName: '',
            time: '',
            type: '',
            garbage: true,
            id: 'garbage2'
          },
          {
            guid: this.guid(),
            v: '',
            parkName: '',
            time: '',
            type: '',
            garbage: true,
            id: 'garbage3'
          },
          {
            guid: this.guid(),
            v: '',
            parkName: '',
            time: '',
            type: '',
            garbage: true,
            id: 'garbage4'
          }
        ];
        arr.length = arrlength;
      }

      this.$nextTick(() => {
        try {
          if (this.operationDtos.length > 0) {
            (this.$refs['realtimeeasy'] as any).appendData(
              this.operationDtos
                .map((item, index) => ({
                  guid: this.guid(),
                  v: item,
                  parkName: item.parkName,
                  time: item.time,
                  type: item.type,
                  // garbage: index >= 2,
                  id: '' + Date.now() + Math.random()
                }))
                .concat(this.hasdatavGarbageData ? [] : arr),
              (this.hasdatavGarbageData = true)
            );
          }
        } catch (e) {
          console.log(e);
        }
      });
    }
  }
  async getFivedatavOperation() {
    let json = { parkIds: this.parkIds };
    try {
      const res = await operationFiveMinute(json);
      if (res.data && res.data.onlineParkNum && res.data.onlineRate && res.data.operationDtos) {
        const { onlineParkNum, onlineRate, operationDtos } = res.data;
        // this.onlineParkNum = onlineParkNum || ''
        // this.onlineRate = onlineRate || ''
        gsap.to(this.$data, { duration: 0.5, onlineParkNumTweened: res.data.onlineParkNum || 0 });
        gsap.to(this.$data, { duration: 0.5, onlineRateTweened: res.data.onlineRate || 0 });
        // this.operationDtos = operationDtos || []
        if (res.data && res.data.operationDtos && operationDtos.length > 0) {
          this.operationDtos = operationDtos || [];
          this.$nextTick(() => {
            try {
              (this.$refs['realtimeeasy'] as any).appendData(
                this.operationDtos.map((item, index) => ({
                  guid: this.guid(),
                  v: item,
                  parkName: item.parkName,
                  time: item.time,
                  type: item.type,
                  // garbage: index >= 2,
                  id: '' + Date.now() + Math.random()
                }))
              );
            } catch (e) {
              console.log(e);
            }
          });
        }
      }
      this.zaixianTranslate = !this.zaixianTranslate;
    } catch (e) {
      this.$message.error((e && e.msg) || '获取数据失败');
    }
  }
  //获取parkIds
  async getParkIds(provinceId = null) {
    try {
      const { data } = await getParkIds({ orgDepId: this.orgDepId, userId: this.dataUserId, provinceId: provinceId });
      this.parkIds = data;
    } catch (e) {
      console.log(e);
      this.$message.error((e && e.msg) || '系统异常请稍后再试');
    }
  }

  async getUserOnlyId() {
    try {
      // this.userLoading = false
      const { data } = await getUserId();
      this.dataUserId = data;
    } catch (e) {
      console.log(e);
    }
  }

  // @Watch('orgId')
  // fileListChange(v: any) {
  //   console.log('监听===》', v)
  // }
  //初始化所有数据
  orgName: any = '';
  async initData(provinceId = null) {
    this.screenLoading = true;
    this.clearAllTimer();
    this.trafficStatus = 0;
    this.revenueStatus = 0;
    //通行
    this.trafficRateTweened = 0;
    this.todayEnterTweened = 0;
    this.todayOutTweened = 0;
    //营收
    this.monthCardTweened = 0;
    this.temporaryRateTweened = 0;
    this.temporaryRevenueTweened = 0;
    //总览
    this.parkNumTweened = 0;
    this.parkingSpaceNumTweened = 0;
    this.todayPaymentNumTweened = 0;
    this.todayRevenueSumTweened = 0;
    //
    this.onlineParkNumTweened = 0;
    this.onlineRateTweened = 0;

    if (this.isFull) {
      this.dataUserId = this.$route.query.userId || '';
      this.orgDepId = this.$route.query.orgDepId || '';
      this.orgName = this.$route.query.orgDepName || '----';
    } else {
      this.dataUserId = this.userId || '';
      this.orgDepId = this.orgId;
      this.orgName = this.orgDepName;
    }
    if (!this.dataUserId) return;
    await this.getParkIds(provinceId);
    this.getTrafficLineData();
    this.getabnormalTraffic();
    this.getdatavOperation();
    this.getTrafficData();
    this.getRevenueLineDate();
    this.getRevenueDate();
    this.getPayData();
    this.getParkingMap();
    this.getOverviewDataVisualizationData();
    this.timer = setInterval(() => {
      // this.getabnormalTraffic()
      // this.getfiveabnormalTraffic()
      // this.shuffle()
      this.getChange();
      this.getTrafficData();
      this.getRevenueDate();
      this.getOverviewDataVisualizationData();
    }, 5000);
    this.systemTimer = setInterval(() => {
      let newTime = Utils.getFormatTime(new Date(), 'yyyy-MM-DD HH:mm:ss');
      this.systemTime = newTime.substr(0, 10);
      this.systemHour = newTime.substr(11, 2);
      this.systemMin = newTime.substr(14, 2);
      this.systemSec = newTime.substr(17, 2);
      if (this.systemMin == '00' && this.systemSec == '00') {
        //整点刷新
        console.log('整点');
        if (this.mapDataTimer) {
          clearInterval(this.mapDataTimer);
        }
        //更新地图车流量
        this.getParkingMap();
        //更新进出场通行折线图
        this.trafficStatus = 0;
        this.getTrafficLineData();
        //更新临停营收折线图
        this.revenueStatus = 0;
        this.getRevenueLineDate();
        //更新临停营收渠道
        this.getPayData();
        // 总览
        this.getOverviewDataVisualizationData();
        // this.getdatavOperation()
        this.getFivedatavOperation();
        // this.getabnormalTraffic()
        this.getfiveabnormalTraffic();
      }
    }, 1000);
    //十秒刷新
    this.tenTimer = setInterval(() => {
      //更新两个tab
      this.trafficStatus = this.trafficStatus == 0 ? 1 : 0;
      this.getTabTraffic();
      this.revenueStatus = this.revenueStatus == 0 ? 1 : 0;
      this.getTabrevenue();
    }, 10000);
    this.thirtyTimer = setInterval(() => {
      this.getfiveabnormalTraffic();
    }, 30000);
    //五分钟刷新
    this.timeFive = setInterval(() => {
      // 更新地图车场数量;
      this.getabnormalTraffic();
      this.getdatavOperation();
      this.getFivedatavOperation();
      //更新地图车流量
      this.getParkingMap();
    }, 300000);
  }
  getChange() {
    this.on = !this.on;
  }
  //清除定时
  clearAllTimer() {
    clearInterval(this.timer);
    clearInterval(this.abnormalTimer);
    clearInterval(this.systemTimer);
    clearInterval(this.timeFive);
    clearInterval(this.tenTimer);
    clearInterval(this.thirtyTimer);
    clearInterval(this.mapDataTimer);
  }
  async redirectToLogin(isSingle?: boolean) {
    localCache.clear();
    try {
      if (window.location.hash === '#/auth/login') return;
      window.location.href = `#/auth/login?redirect=all-screen&userId=${this.$route.query.userId}&orgDepId=${this.$route.query.orgDepId}&orgDepName=${this.$route.query.orgDepName}`;
      // if (isSingle) {
      //   if (window.location.hash === '#/auth/single-out') return;
      //   window.location.href = '#/auth/single-out';
      // } else {
      //   if (window.location.hash === '#/auth/login') return;
      //   window.location.href = `#/auth/login?redirect=all-screen&userId=${this.$route.query.userId}&orgDepId=${this.$route.query.orgDepId}&orgDepName=${this.$route.query.orgDepName}`;
      // }
    } catch (e) {
      console.error(e);
    }
  }
  //初始化数据
  async mounted() {
    //如果全屏
    if (this.isFull) {
      await this.getConfigDetail();
      if (this.datavConfig == '00') {
        try {
          this.screenLoading = true;
          const res = await checkLogin({
            userId: this.$route.query.userId || '',
            orgDepId: this.$route.query.orgDepId || ''
          });
          this.screenLoading = false;
          if (res.data) {
            this.initData();
          } else {
            this.redirectToLogin();
          }
        } catch (e) {
          console.log(e);
        } finally {
          this.screenLoading = false;
        }
      } else {
        this.initData();
      }
    }
  }
  destroyed() {
    this.clearAllTimer();
  }
  //更新省份ID
  updateProvinceId(newValue: string | null) {
    this.initData(newValue);
  }

  //获取全局配置详情
  async getConfigDetail() {
    try {
      const { data } = await getDataVConfig();
      this.datavConfig = data.datavConfig;
    } catch (e) {
      console.log(e);
    }
  }
}
